"use client";

import React, { useEffect, useRef } from "react";

// YouTube embed URL generator
const getYouTubeEmbedUrl = (url) => {
  try {
    const yt = new URL(url);
    const videoId = yt.hostname.includes("youtu.be")
      ? yt.pathname.slice(1)
      : yt.searchParams.get("v");

    return `https://www.youtube.com/embed/${videoId}?rel=0`;
  } catch (err) {
    return url;
  }
};

// Instagram Embed Component
const InstagramEmbed = ({ url }) => {
  const ref = useRef();

  useEffect(() => {
    if (window.instgrm) {
      window.instgrm.Embeds.process();
    } else {
      const script = document.createElement("script");
      script.src = "https://www.instagram.com/embed.js";
      script.async = true;
      script.onload = () => window.instgrm?.Embeds.process();
      document.body.appendChild(script);
    }
  }, [url]);

  return (
    <div className="max-w-[540px] max-h-[80vh] overflow-y-auto mx-auto pt-4 flex justify-center">
      <blockquote
        ref={ref}
        className="instagram-media"
        data-instgrm-permalink={url}
        data-instgrm-version="14"
        style={{ margin: "0 auto" }}
      ></blockquote>
    </div>
  );
};

// TikTok Embed Component
const TikTokEmbed = ({ url }) => {
  const ref = useRef();

  useEffect(() => {
    if (window.tiktokEmbed) {
      window.tiktokEmbed.load();
    } else {
      const script = document.createElement("script");
      script.src = "https://www.tiktok.com/embed.js";
      script.async = true;
      script.onload = () => window.tiktokEmbed?.load();
      document.body.appendChild(script);
    }
  }, [url]);

  const videoId = url.split("/").filter(Boolean).pop();

  return (
    <div className="max-w-[605px] max-h-[80vh] overflow-y-auto mx-auto pt-4 flex justify-center">
      <blockquote
        ref={ref}
        className="tiktok-embed"
        cite={url}
        data-video-id={videoId}
        style={{ margin: "0 auto" }}
      >
        <section>Loading TikTok video...</section>
      </blockquote>
    </div>
  );
};

// MAIN COMPONENT
const ToolIframe = ({ demoLink }) => {
  if (!demoLink) return null;

  let embedContent;

  try {
    const url = new URL(demoLink);
    const hostname = url.hostname.toLowerCase();

    if (hostname.includes("youtube.com") || hostname.includes("youtu.be")) {
      const embedLink = getYouTubeEmbedUrl(demoLink);
      embedContent = (
        <div className="relative w-full pt-[56.25%] overflow-hidden border mb-4">
          <iframe
            src={embedLink}
            title="YouTube Demo Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="absolute top-0 left-0 w-full h-full"
          ></iframe>
        </div>
      );
    } else if (hostname.includes("instagram.com")) {
      embedContent = <InstagramEmbed url={demoLink} />;
    } else if (hostname.includes("tiktok.com")) {
      embedContent = <TikTokEmbed url={demoLink} />;
    } else {
      embedContent = (
        <div className="text-center neue_machina_regular">
          <a
            href={demoLink}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs sm:text-sm text-blue-600 underline hover:text-blue-800"
          >
            Video not supported for embedding. Click here to watch it directly.
          </a>
        </div>
      );
    }
  } catch (err) {
    embedContent = (
      <div className="text-center text-red-600">Invalid video URL.</div>
    );
  }

  return <div>{embedContent}</div>;
};

export default ToolIframe;
